import React from 'react';

interface RouteIconProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  fill?: string;
}

export const RouteIcon: React.FC<RouteIconProps> = ({
  width = '20',
  height = '20',
  className,
  fill = '#9AEEE6',
}) => {
  return (
    <svg
      viewBox="0 0 20 20"
      className={className}
      width={width}
      height={height}
      fill={fill}
    >
      <path d="M15.3792 6.21542C16.2315 6.21542 17.0001 5.70232 17.3269 4.91487C17.6536 4.12742 17.4735 3.22059 16.8703 2.61743C16.2671 2.01428 15.3603 1.83417 14.5729 2.16088C13.7854 2.48759 13.2723 3.25619 13.2723 4.10857C13.2723 5.27299 14.2168 6.21542 15.3813 6.21752L15.3792 6.21542Z" />
      <path d="M3.96319 17.9979C4.81556 17.9979 5.58417 17.4848 5.91088 16.6974C6.23759 15.9099 6.05748 15.0031 5.45432 14.3999C4.85116 13.7968 3.94434 13.6166 3.15688 13.9434C2.36943 14.2701 1.85633 15.0387 1.85633 15.891C1.85633 17.0555 2.80085 17.9979 3.96528 18L3.96319 17.9979Z" />
      <path d="M15.7268 9.3443H4.27316C3.06895 9.3443 2.09301 8.36626 2.09091 7.16205V6.94424C2.09091 5.74002 3.06895 4.76408 4.27316 4.76199H11.3079C11.6702 4.76199 11.9613 4.46879 11.9613 4.10857C11.9613 3.74835 11.6681 3.45515 11.3079 3.45515H4.27316C3.34749 3.45515 2.45951 3.82375 1.80609 4.47926C1.15267 5.13268 0.781982 6.01856 0.781982 6.94424V7.16205C0.781982 8.08772 1.15267 8.9757 1.80609 9.62912C2.45951 10.2825 3.34749 10.6511 4.27316 10.6532H15.7268C16.9311 10.6532 17.907 11.6313 17.9091 12.8355V13.0533C17.9091 14.2575 16.9311 15.2334 15.7268 15.2355H8.0366C7.67429 15.2355 7.38319 15.5287 7.38319 15.889C7.38319 16.2492 7.67639 16.5424 8.0366 16.5424H15.7268C16.6525 16.5424 17.5405 16.1738 18.1939 15.5183C18.8473 14.8648 19.2159 13.9769 19.218 13.0512V12.8334C19.218 11.9077 18.8473 11.0197 18.1939 10.3663C17.5405 9.71289 16.6525 9.3443 15.7268 9.3422V9.3443Z" />
    </svg>
  );
};
